import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IFormAnswerSet } from '@fi-shared/fi-form-shared/fi-form-shared';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-form-answer-set-list',
    templateUrl: './fi-form-answer-set-list.component.html',
    styleUrls: ['./fi-form-answer-set-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-form-answer-set-list' },
    standalone: false,
})
export class FiFormAnswerSetListComponent {
    @Input() answerSets: IFormAnswerSet[];

    protected readonly FiStateNames = FiStateNames;
}
